module.exports = __webpack_public_path__ + "img/pc_p2_dizhiti.9f6ba40c.png";